/**
 * Component: EventTriggerStep
 * Step 1 form fields for Program creation/edit - Event Trigger configuration.
 */

import { Input } from "@/components/ui/input";
import { Select } from "@/components/ui/select";
import type { ProgramFormData } from "@/feature/programs/domain/model";

const channelOptions = [
  { value: "", label: "Select Channel", disabled: true },
  { value: "DigiPOS", label: "DigiPOS" },
  { value: "MyTsel", label: "MyTsel" },
  { value: "Duwit", label: "Duwit" },
];

interface EventTriggerStepProps {
  formData: ProgramFormData;
  errors: Partial<Record<keyof ProgramFormData, string>>;
  onInputChange: (field: keyof ProgramFormData, value: string) => void;
}

export const EventTriggerStep = ({
  formData,
  errors,
  onInputChange,
}: EventTriggerStepProps): React.JSX.Element => {
  return (
    <div className="grid grid-cols-2 gap-6">
      {/* Program Name */}
      <div className="flex flex-col gap-1.5">
        <label
          htmlFor="program-name"
          className="text-sm font-semibold text-gray-800 text-left"
        >
          Program Name
        </label>
        <Input
          id="program-name"
          type="text"
          value={formData.programName}
          onChange={(e) => onInputChange("programName", e.target.value)}
          placeholder="Program Name"
          errorMessage={errors.programName}
        />
      </div>

      {/* Channel */}
      <div className="flex flex-col gap-1.5">
        <label
          htmlFor="channel"
          className="text-sm font-semibold text-gray-800 text-left"
        >
          Channel
        </label>
        <Select
          id="channel"
          value={formData.channel}
          onChange={(e) => onInputChange("channel", e.target.value)}
          options={channelOptions}
          errorMessage={errors.channel}
        />
      </div>

      {/* Start Date */}
      <div className="flex flex-col gap-1.5">
        <label
          htmlFor="start-date"
          className="text-sm font-semibold text-gray-800 text-left"
        >
          Start Date
        </label>
        <Input
          id="start-date"
          type="date"
          value={formData.startDate}
          onChange={(e) => onInputChange("startDate", e.target.value)}
          placeholder="Start Date"
          errorMessage={errors.startDate}
        />
      </div>

      {/* End Date */}
      <div className="flex flex-col gap-1.5">
        <label
          htmlFor="end-date"
          className="text-sm font-semibold text-gray-800 text-left"
        >
          End Date
        </label>
        <Input
          id="end-date"
          type="date"
          value={formData.endDate}
          onChange={(e) => onInputChange("endDate", e.target.value)}
          placeholder="End Date"
          errorMessage={errors.endDate}
        />
      </div>
    </div>
  );
};

